import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http } from "@/lib/api";
import { useVisitorAuth } from "@/context/VisitorAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function VisitorAuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setVisitor, refresh } = useVisitorAuth();
    const processed = useRef(false);
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        if (!sessionId) {
            navigate("/sign-in", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await http.post("/visitor/auth/session", { session_id: sessionId });
                setVisitor({ ...data.user, lead_id: null });
                // clean the hash from the URL
                window.history.replaceState(null, "", window.location.pathname);
                await refresh();
                if (data.needs_profile) {
                    navigate("/complete-profile", { replace: true });
                } else {
                    navigate("/my-account", { replace: true });
                }
            } catch (e) {
                setErr(e.response?.data?.detail || "Sign-in failed. Please try again.");
            }
        })();
    }, []); // eslint-disable-line

    return (
        <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center">
                {err ? (
                    <div>
                        <div className="text-red-400 font-semibold">{err}</div>
                        <button
                            onClick={() => navigate("/sign-in", { replace: true })}
                            className="mt-4 btn-primary"
                        >
                            Back to sign in
                        </button>
                    </div>
                ) : (
                    <div className="flex items-center gap-3 text-slate-300">
                        <Loader2 className="w-5 h-5 animate-spin text-emerald-400" />
                        Signing you in…
                    </div>
                )}
            </div>
        </div>
    );
}
